enum IssueReasonEnum {
    INSUFFICIENT_QTY = 1,
    SUBSTITUTION = 2,
    DAMAGED_PRODUCT = 3,
    OTHER = 4,
}

export default IssueReasonEnum;
